<template>
  <layout title="Courses">
    <div class="row mb-4">
      <div class="col-10">
        <h2>
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.index')"
          >
            Classrooms
          </inertia-link>
          /
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.edit', classroom.data.id)"
          >
            {{ classroom.data.name }}
          </inertia-link>
          / Sessions
        </h2>
      </div>

      <div class="col-2">
        <inertia-link
          class="btn btn-primary float-right"
          :href="route('classrooms.sessions.create', classroom.data.id)"
        >
          + Add New
        </inertia-link>
      </div>
    </div>

    <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
      <div class="card-body">
        <FlashMessage :flash="flash" />

        <div class="row mb-2">
          <div class="col-md-8"></div>
          <div class="col-md-4">
            <form @submit.prevent="search()">
              <input
                v-model="searchQuery"
                type="text"
                class="form-control"
                placeholder="Search.."
              />
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <table class="table">
              <thead class="thead-light xthead-dark">
                <tr>
                  <th scope="col">Start at</th>
                  <th scope="col">End at</th>
                  <th scope="col">Timezone</th>
                  <th scope="col">Accept</th>
                  <th scope="col">Status</th>
                  <th scope="col">Created Date</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="session in sessions.data" :key="session.id" @click="navigateToEdit(session.id)">
                  <td>{{ session.start_datetime }}</td>
                  <td>{{ session.end_datetime }}</td>
                  <td>{{ session.timezone }}</td>
                  <td>{{ session.auto_accept ? 'Auto' : 'Manual' }}</td>
                  <td><pre>{{ session.status }}</pre></td>
                  <td>{{ session.created_at }}</td>
                  <td>                    
                    <button
                      v-if="session.status != 'COMPLETED'"
                      type="button"
                      class="btn btn-sm x-btn-danger btn-outline-danger"
                      @click.stop="showDeleteConfirmationModal(session)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!sessions.data || !sessions.data.length">
                <tr>
                  <td colspan="7">No data to display</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <nav aria-label="Page navigation example" v-if="sessions && sessions.meta">
          <ul class="pagination justify-content-end">
            <li
              class="page-item"
              :class="{ active: link.active }"
              v-for="link in sessions.meta.links"
              :key="link.label"
            >
              <inertia-link
                v-if="link.url"
                class="page-link"
                :href="link.url"
                preserve-scroll
              >
                <span v-html="link.label"></span>
              </inertia-link>
              <span class="page-link" v-else>
                <span v-html="link.label"></span>
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div
      class="modal fade"
      id="deleteConfirmationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Delete Record - {{ selectedRecord && selectedRecord.start_datetime }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Are you sure you want to delete the record - 
            <strong>{{ selectedRecord && selectedRecord.start_datetime }}</strong> ?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>

            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="
                deleteRecord(selectedRecord ? selectedRecord.id : null)
              "
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    errors: Object,
    classroom: Object,
    sessions: Object,
    flash: Object
  },
  data() {
    return {
      selectedRecord: null,
    };
  },
  methods: {
    search() {
      this.$inertia.get(route("classrooms.index"), {
        search_query: this.searchQuery,
      });
    },
    showDeleteConfirmationModal(record) {
      this.selectedRecord = record;
      $("#deleteConfirmationModal").modal("show");
    },
    deleteRecord(id) {
      this.$inertia.delete(route("classrooms.sessions.destroy", id));
    },
    navigateToEdit(Id) {
      this.$inertia.get(route('classrooms.sessions.edit', Id))
    }
  },
};
</script>